var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.16659 18.3333H15.8333C16.2935 18.3333 16.6666 17.9602 16.6666 17.5V5.83332L12.9166 1.66666H4.16659C3.70635 1.66666 3.33325 2.03975 3.33325 2.49999V17.5C3.33325 17.9602 3.70635 18.3333 4.16659 18.3333Z","stroke":"#007185","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.5 1.66666V5.83332H16.6667","stroke":"#007185","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

File.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = File;

File.default = File;
